var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"primary":"","dark":"","disabled":_vm.loading,"large":""},on:{"click":_vm.login}},[(_vm.loading)?_c('span',[_vm._v("Logging in...")]):_vm._e(),(!_vm.loading)?_c('span',[_vm._v("Login with Ethereum")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }